<div class="alertPanel d-flex justify-content-between align-items-center position-relative"
    [ngClass]="{'warnColorBorder': alertType === 'error','warnAccentColorBorder': alertType === 'warning', 
    'accentColorBorder': alertType === 'info', 'overlayPanel' : overlayPanel}">
  <div class="d-flex align-items-start position-relative">
    <div [innerHTML]="icons[alertType === 'error' ? 'alert' : 'info-outline']"
            class="panelIcon" [ngClass]="{ 'warnColorIcon': alertType === 'error', 
            'warnAccentColorIcon': alertType === 'warning', 'accentColorIcon': alertType === 'info'}">
    </div>
    <div class="d-flex flex-column">
      <p class="paragraphText" [ngClass]="{'darkText' : overlayPanel}">
        @if (boldPrefix !== '') {
          <strong>{{ boldPrefix }}</strong>
        }
        {{ titleText }}
      </p>
      <p class="paragraphText" [ngClass]="{'darkText' : overlayPanel}">{{ descriptionText }}</p>
    </div>
  </div>

  <div class="alertContent d-flex align-items-center">
    @if (buttonLabel) {
      <button mat-stroked-button class="btn actionButton"
      (click)="execAction()"> {{ buttonLabel }}</button>
    }
        <div class="pipeElement" [ngClass]="{'warnColorBG': alertType === 'error',
            'warnAccentColorBG': alertType === 'warning', 'accentColorBG': alertType === 'info'}"></div>
    <div [innerHTML]="icons['close']" class="closeIcon" (click)="closePanel()"></div>
  </div>
    <div class="position-absolute backgroundOpacity" [ngClass]="{'warnColorBG': alertType === 'error',
        'warnAccentColorBG': alertType === 'warning', 'accentColorBG': alertType === 'info'}">
  </div>
</div>